import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DisclaimerModalActionsEnum, DisclaimerModalOptions } from './models';

export const DEFAULT_DISCLAIMER_MODAL_OPTIONS: DisclaimerModalOptions = {
  back: 'Back',
  accept: 'Accept',
  decline: 'Decline',
  modalTitle: 'Disclaimer',
  backButtonEnabled: false,
};

@Component({
  selector: 'grid-ui-data-wizard-disclaimer-modal',
  templateUrl: './disclaimer-modal.component.html',
  styleUrls: ['./disclaimer-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DisclaimerModalComponent {
  @Input() public modalOptions: DisclaimerModalOptions = DEFAULT_DISCLAIMER_MODAL_OPTIONS;
  @Output() public readonly modalAction = new EventEmitter<DisclaimerModalActionsEnum>();

  public fullYear = new Date().getFullYear();

  public onAcceptClick(): void {
    this.modalAction.emit(DisclaimerModalActionsEnum.Accept);
  }

  public onDeclineClick(): void {
    this.modalAction.emit(DisclaimerModalActionsEnum.Decline);
  }

  public cancel(): void {
    this.modalAction.emit(DisclaimerModalActionsEnum.Close);
  }

  public onBack(): void {
    this.modalAction.emit(DisclaimerModalActionsEnum.Back);
  }
}
